import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { paths } from '@mc/paths'

import CTA from 'components/CTA'
import Image from 'components/LegacyImage'

import { checkoutCtaTrackProps } from './constants'

const FooterContentDesktop = () => {
  const { t } = useTranslation('@mc/next')
  const { guestPass } = useStaticData()

  return (
    <div className='row'>
      <div className='col-8 d-flex align-items-center'>
        {guestPass.advocate.profile_image && (
          <Image
            alt=''
            className='mc-corners--circle mc-mr-4'
            height={56}
            src={guestPass.advocate.profile_image}
            width={56}
          />
        )}
        <div className='mc-mr-4'>
          <h2 className='mc-text-h2 mc-text--brand mc-text--uppercase mc-mb-2 d-flex'>
            {t('guestPass.footer.title', { name: guestPass.advocate.name })}
          </h2>
          <h6 className='mc-text-h8'>{t('guestPass.footer.description')}</h6>
        </div>
      </div>
      <div className='col-4 d-flex align-items-center justify-content-end'>
        <CTA href={paths.checkout} trackProps={checkoutCtaTrackProps}>
          {t('guestPass.footer.cta.desktop')}
        </CTA>
      </div>
    </div>
  )
}

export default FooterContentDesktop
